// extracted by mini-css-extract-plugin
module.exports = {"card":"MyCard_card__2g8dB"};